module.exports = __webpack_public_path__ + "img/pic04@2x.8cce77e7.png";